var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0747 0.999886L0.590308 9.35614C0.0246828 9.68114 0.0965578 10.4686 0.659058 10.7061L3.98093 12.0999L12.9591 4.18739C13.1309 4.03426 13.3747 4.26864 13.2278 4.44676L5.69968 13.6186V16.1343C5.69968 16.8718 6.59031 17.1624 7.02781 16.628L9.01218 14.2124L12.9059 15.8436C13.3497 16.0311 13.8559 15.753 13.9372 15.2749L16.1872 1.77489C16.2934 1.14364 15.6153 0.687386 15.0747 0.999886Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegramIcon.d5d53871580db6db1c0faeb47c658ee5.svg";
export { ForwardRef as ReactComponent };